// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ota-simple-notification[data-v-3034c6f7]{background-color:#f79f07}.ota-simple-notification.rounded-6[data-v-3034c6f7]{border-radius:.6rem}.ota-simple-notification .is-active-badge[data-v-3034c6f7]{height:2.6rem;width:2.6rem}.ota-simple-notification .is-active-badge svg[data-v-3034c6f7]{position:absolute;top:27%;left:27%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
